import React, { FC, useState, useCallback, useEffect } from 'react';
import debounce from 'lodash.debounce';
import styles from './Overlay.module.scss';

// type SearchSectionProps = {
//   postcode: string;
//   onChangePostcode: (value: string) => void;
//   onSearch: () => void;
//   onStart: () => void;
//   fetchLocations: (inputText: string) => void;
// };

const SearchSection = ({ fetchLocations, onStart, postcodeError, fields }) => {
  const [inputText, setInputText] = useState('');

  const onClickClear = () => {
    onStart();
    setInputText('');
  };

  const debouncedFetchLocations = useCallback(
    debounce((input) => fetchLocations(input), 300),
    [fetchLocations]
  );

  useEffect(() => {
    debouncedFetchLocations(inputText);
    return () => {
      debouncedFetchLocations.cancel();
    };
  }, [inputText]);

  return (
    <div className={styles.searchSection}>
      <input
        className={postcodeError ? `${styles.input} ${styles.inputError}` : styles.input}
        type="text"
        value={inputText}
        placeholder="Enter your postcode"
        onChange={(e) => setInputText(e.target.value)}
      />
      {inputText && (
        <svg
          className={styles.closeIcon}
          onClick={onClickClear}
          height="512px"
          id="Layer_1"
          version="1.1"
          viewBox="0 0 512 512"
          width="512px"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M437.5,386.6L306.9,256l130.6-130.6c14.1-14.1,14.1-36.8,0-50.9c-14.1-14.1-36.8-14.1-50.9,0L256,205.1L125.4,74.5  c-14.1-14.1-36.8-14.1-50.9,0c-14.1,14.1-14.1,36.8,0,50.9L205.1,256L74.5,386.6c-14.1,14.1-14.1,36.8,0,50.9  c14.1,14.1,36.8,14.1,50.9,0L256,306.9l130.6,130.6c14.1,14.1,36.8,14.1,50.9,0C451.5,423.4,451.5,400.6,437.5,386.6z" />
        </svg>
      )}
      {postcodeError && (
        <div id="postcode-error" className={styles.errorMessageContainer}>
          <div className={styles.errorMessage}>{fields?.postcodeErrorText?.value}</div>
        </div>
      )}
    </div>
  );
};

export default SearchSection;
